import React from "react";
import { FileSignature, FileX2 } from "lucide-react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("fr-CH") : null);

// Statut de signature du document de remise pour un employé (signed_status: all | partial | none | null)
export const SIG_CARD_CLASS = { all: "sig-all", partial: "sig-partial", none: "sig-none" };

export function EmployeeSignatureBadge({ employee, size = "xs", testId }) {
    const { signed_status: status, signed_items = 0, unsigned_items = 0 } = employee;
    if (!status) return null;
    const total = signed_items + unsigned_items;
    const cfg = {
        all: { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: total > 1 ? `Remise signée (${total}/${total})` : "Remise signée", Icon: FileSignature },
        partial: { cls: "bg-amber-50 text-amber-700 border-amber-200", label: `${signed_items}/${total} signé(s)`, Icon: FileSignature },
        none: { cls: "bg-red-50 text-red-700 border-red-200", label: "Remise non signée", Icon: FileX2 },
    }[status];
    const sz = size === "sm" ? "text-[11px] px-2 py-0.5" : "text-[9px] px-1.5 py-0.5";
    return (
        <span className={`inline-flex items-center gap-1 rounded-full border font-medium whitespace-nowrap ${sz} ${cfg.cls}`} data-testid={testId} title="Document de remise IT signé par le collaborateur">
            <cfg.Icon className={size === "sm" ? "w-3.5 h-3.5" : "w-3 h-3"} />{cfg.label}
        </span>
    );
}

// Indicateur par équipement (item.remise_signed: true | false | null)
export function ItemSignatureBadge({ item, compact = false, testId }) {
    if (item.remise_signed === null || item.remise_signed === undefined) return null;
    if (item.remise_signed) {
        const d = fmt(item.remise_signed_date);
        return (
            <span className="inline-flex items-center gap-0.5 text-[9px] px-1.5 py-0.5 rounded-full bg-emerald-50 text-emerald-700 whitespace-nowrap" title={`Remise signée${d ? ` le ${d}` : ""}`} data-testid={testId}>
                <FileSignature className="w-3 h-3" />{compact ? "Signée" : `Remise signée${d ? ` · ${d}` : ""}`}
            </span>
        );
    }
    return (
        <span className="inline-flex items-center gap-0.5 text-[9px] px-1.5 py-0.5 rounded-full bg-red-50 text-red-600 whitespace-nowrap" title="Document de remise non signé" data-testid={testId}>
            <FileX2 className="w-3 h-3" />{compact ? "Non signée" : "Remise non signée"}
        </span>
    );
}
